export const environment = {
  apiURL: 'https://dev.customo.club',
  url: 'http://localhost:4200',
};
